import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Categorysupport } from "src/app/shared/classes/categorysupport";
import { Meta, Title } from "@angular/platform-browser";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: "app-category-support",
  templateUrl: "./category-support.component.html",
  styleUrls: ["./category-support.component.scss"],
})
export class CategorySupportComponent implements OnInit {
  supportAndBlogCategory: Categorysupport = {} as Categorysupport;
  imgPath: string = "";
  parent_id: string = "";
  private searchE: ElementRef;
  loadingSearch: boolean = false;
  searchList: any = [];
  isDropdownVisible: boolean = false;
  searchData: string = "";
  loadingData: boolean = true;
  description: string = "";
  @ViewChild("searchE") set contentX(contentX: ElementRef) {
    if (contentX) {
      this.searchE = contentX;
    }
  }

  constructor(
    public Common: CommonService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private router: Router,
    private title: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.imgPath = Common._ImageUrl + "support-and-blog/";
  }

  ngOnInit(): void {
    this.getSupportAndBlogCategoryById();
    this.renderer.listen("window", "click", (e: Event) => {
      if (this.searchE) {
        if (e.target != this.searchE.nativeElement) {
          this.isDropdownVisible = false;
        }
      }
    });
  }

  getSupportAndBlogCategoryById() {
    this.loadingData = true;
    this.route.params.subscribe((params) => {
      console.log(params.id);
      this.parent_id = params.id;
      this.title.setTitle(params.name.split("-").join(" "));
      this.Common.getSupportAndBlogCategoryById(this.parent_id).subscribe({
        next: (res) => {
          if (res.success) {
            this.supportAndBlogCategory = res.data;
            if (this.supportAndBlogCategory.ser_description) {
              this.description =
                this.supportAndBlogCategory.ser_description.replace(
                  /<\/?[^>]+(>|$)/g,
                  ""
                );
              this.Common.setMeta("description", this.description);
              this.Common.setMeta("", this.description, true, "og:description");
            }
            this.Common.setMeta(
              "",
              params.name.split("-").join(" "),
              true,
              "og:title"
            );
            this.Common.setMeta("", this.document.URL, true, "og:url");
            this.Common.setMeta(
              "",
              this.imgPath + this.supportAndBlogCategory.img_banner,
              true,
              "og:image"
            );
            this.Common.setMeta("", "support", true, "og:type");
            this.meta.removeTag('name="keywords"');

            this.loadingData = false;
          } else {
            this.router.navigate(["/not-found"]);
          }
        },
        error: (err: HttpErrorResponse) => {
          console.log(err);
        },
      });
    });
  }

  getSearchSupportPage(value) {
    if (value.length > 2) {
      this.isDropdownVisible = true;
      this.loadingSearch = true;
      this.Common.getSearchSupportPage(value, this.parent_id).subscribe({
        next: (res) => {
          if (res.success) {
            console.log(res);
            this.loadingSearch = false;
            this.searchList = res.data;
          } else {
            this.loadingSearch = false;
            this.searchList = [];
          }
        },
        error: (err: HttpErrorResponse) => {
          console.log(err);
        },
      });
    } else {
      this.isDropdownVisible = false;
    }
  }
  handleImageError(e) {
    e.src = "assets/images/product/placeholder.jpg";
  }
  clearInputSearch(): void {
    this.searchData = "";
    this.isDropdownVisible = false;
  }
}
